export default {
  single: {
    value: "single",
    label: "Single cutters",
    cutsThisManyTimes: 1
  },
  double: {
    value: "double",
    label: "Double cutters",
    cutsThisManyTimes: 2
  },
  triple: {
    value: "triple",
    label: "Triple cutters",
    cutsThisManyTimes: 3
  }
};
